'use client';

import { createFileRoute, useNavigate, useParams } from '@tanstack/react-router';

import { MemberHistoryConnectionsPage } from '@/features/team/components/member-history-connections-page';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/settings/team/members/$userId/history-connections')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.teamMemberHistoryConnections'),
  }),
  component: TeamMemberHistoryConnectionsRoute,
});

function TeamMemberHistoryConnectionsRoute() {
  const navigate = useNavigate();
  const { userId } = useParams({
    from: '/_authenticated/settings/team/members/$userId/history-connections',
  });

  return (
    <div className="min-h-screen bg-background p-8">
      <div className="mx-auto max-w-7xl">
        <MemberHistoryConnectionsPage
          userId={userId}
          onNavigateBack={() => {
            void navigate({ to: '/settings/team' });
          }}
          onOpenProfile={() => {
            void navigate({ to: '/settings/team/members/$userId', params: { userId } });
          }}
        />
      </div>
    </div>
  );
}
